export type InstanceDefaultValuesMap = Record<string, Record<string, any>>

export const fetchDefaultValues = async (): Promise<InstanceDefaultValuesMap> => {
  const url = new URL(
    `${process.env.REACT_APP_AWS_ASSET_BUCKET_URL}/court-case-invoicing/court_case_invoicing_default_values.json`
  )

  const json = await fetch(url, {
    method: 'GET',
    headers: {
      accept: 'application/json'
    }
  }).then((res) => res.json())

  if (!json || typeof json !== 'object') {
    throw new Error('Invalid JSON')
  }

  const parsed: InstanceDefaultValuesMap = {}

  for (const key of Object.keys(json)) {
    const value = (json as Record<string, unknown>)[key]

    const defaults = parseInvoicingDefaultValues(value)
    if (defaults) {
      parsed[key] = defaults
    }
  }

  return parsed
}

const parseInvoicingDefaultValues = (item: any): Record<string, any> | null => {
  if (!item || typeof item !== 'object') return null

  const parsedDefaultValues: Record<string, any> = {}

  for (const key of Object.keys(item)) {
    parsedDefaultValues[key] = item[key]
  }

  return parsedDefaultValues
}
